<!--
 * @Author: your name
 * @Date: 2022-03-09 09:57:20
 * @LastEditTime: 2023-02-07 19:02:34
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma202204/components/gotomini2.vue
-->
<template>
  <div class="gotomini">
    <wx-open-launch-weapp
      v-if="isBrowser()"
      id="launch-btn1"
      username="gh_91ef296a510c"
      style="
        position: aboslute;
        width: 330px;
        height: 250px;
        left: 0;
        top: 0;
        z-index: 20;
      "
      path="/pages/index/index"
    >
      <script type="text/wxtag-template">
        <div style="position:aboslute;width:330px;height:250px;left:0;top:0;z-index:20;">

        </div>
      </script>
    </wx-open-launch-weapp>
    <span
      v-if="!isBrowser()"
      style="
        position: absolute;
        width: 330px;
        height: 250px;
        left: 0;
        top: 0;
        z-index: 20;
      "
      @click="gotomini"
    >
    </span>
  </div>
</template>

<script>
export default {
  mounted() {
    try {
      var btn = document.getElementById('launch-btn1');
      btn.addEventListener('launch', (e) => {});
    } catch (error) {
      console.log('error', error);

      var btn = document.getElementById('launch-btn');
      btn.addEventListener('error', (e) => {
        console.log('fail', e.detail);
      });
    }
  },
  methods: {
    gotomini() {
      location.href =
        window.hysdk.sniff.scheme +
        `://miniprogram/launchMiniProgram?userName=gh_91ef296a510c&path=${encodeURIComponent(
          '/pages/index/index',
        )}`;
    },
    isBrowser() {
      if (window.hysdk.sniff.scheme) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="less" scoped="true">
.jumpToMini {
  margin-top: 14px;
  width: 156px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 47px;
  display: inline-block;
}
#launch-btn {
  width: 315px;
}
.gotomini {
  position: absolute;
  width: 330px;
  height: 250px;
  left: 0;
  top: 0;
  z-index: 20;
}
</style>